import { useEffect } from 'react';

const useOutsideClick = (outerRef, centerBoxRef, onClose, dependency = []) => {
  	useEffect(() => {
	    const handleClick = (event) => {
	      	if (centerBoxRef.current && centerBoxRef.current.contains(event.target)) {
	        	// کلیک داخل centerBox بود، کاری نکن
	      	} else {
	        	onClose(); // کلیک خارج، بستن مدال
	      	}
	    };

	    const outerElement = outerRef.current;
	    	if (outerElement) {
	      		outerElement.addEventListener('click', handleClick);
	    	}

	    return () => {
	      	if (outerElement) {
	        	outerElement.removeEventListener('click', handleClick);
	      	}
	    };
  	}, dependency);
};

export default useOutsideClick;
